import { Location } from './location.service'
import { ApiService, ApiError } from './api.service'
import { Constants } from '../constants'

class Region {
    constructor(region) {
        this.id = region ? region.id : undefined
        this.name = region ? region.name : undefined
        this.locations = region && region.locations ? region.locations.map(o => new Location(o)) : []
    }

    getLocations() {
        var locations = []
        for (const location of this.locations) {
            locations.push(location.name)
        }

        return locations.length > 0 ? locations.join(', ') : '-'
    }
}

const RegionService = {

    getRegions: async function() {
        try {
            const response = await ApiService.get(Constants.ENDPOINT_REGIONS)
            return response.data
        }catch(error) {
            throw new ApiError(error)
        }
    },

    getRegion: async function(regionId) {
        try {
            const endpoint = `${Constants.ENDPOINT_REGIONS}/${regionId}`
            const response = await ApiService.get(endpoint)
            return response.data
        }catch(error) {
            throw new ApiError(error)
        }
    },

    createRegion: async function(region) {
        try {
            const response = await ApiService.post(Constants.ENDPOINT_REGIONS, region)
            return response
        }catch(error) {
            throw new ApiError(error)
        }
    },

    updateRegion: async function(region) {
        try {
            const endpoint = `${Constants.ENDPOINT_REGIONS}/${region.id}`
            const response = await ApiService.put(endpoint, region)
            return response
        }catch(error) {
            throw new ApiError(error)
        }
    },

}

export { RegionService, Region }